import React from 'react'
import cn from 'classnames'
import {Stack} from '@src/CommonComponents/Stack/Stack.tsx'
import styles from './filterTiles.module.less'

// Equal-width row of tiles; compact flattens them while a list below is scrolled
export const FilterTiles = ({compact, children}: React.PropsWithChildren<{ compact?: boolean }>) => (
    <Stack className={cn(styles.tiles, {[styles.compact]: compact})} gap={8}>
        {children}
    </Stack>
)

// Colors belong to the page: className for the idle tile, activeClassName once selected
export const FilterTile = ({className, activeClassName, active, onClick, children}: React.PropsWithChildren<{
    className: string,
    activeClassName: string,
    active: boolean,
    onClick: () => void,
}>) => (
    <Stack direction={"column"}
           className={cn(styles.tile, className, {[activeClassName]: active})}
           alignItems={"center"}
           onClick={onClick}
           justifyContent={"center"}>
        {children}
    </Stack>
)
